module.exports = __webpack_public_path__ + "img/aite.2537960d.png";